/**
 * Custom route text configuration
 * Maps route paths to custom display names for breadcrumbs and page titles
 */

export const customRouteTexts: Record<string, string> = {
  // Account routes
  '/account': 'Account',
  '/account/wallet': 'Wallet',
  '/account/wallet/history': 'Transaction History',
  '/account/personal-details': 'Personal Details',
  '/account/change-password': 'Change Password',
  '/account/saved-cards': 'Saved Cards',
  '/account/active-orders': 'Active Orders',
  '/account/past-orders': 'Past Orders',
  '/account/brands': 'Brands',
  '/cdm/points-of-interest': 'Places of interest',
  '/account/integration': 'Integrations',
  '/integrations': 'Integrations',
  '/account/impersonation-logs': 'Impersonation Logs',
  '/account/switch-user': 'Switch User',
  '/account/feature-access': 'Feature Access',
  '/account/organization': 'Team & Access',

  // Campaign routes
  '/campaigns': 'Direct Mail',
  '/campaigns/create-direct-mail-campaign': 'Create Direct Mail Campaign',
  '/campaigns/details': 'Campaign Details',
  '/campaigns/edit': 'Edit Campaign',
  '/campaigns/proof': 'Campaign Proof',
  '/campaigns/configure-informed-delivery': 'Configure Informed Delivery',
  '/campaigns/informed-delivery': 'Informed Delivery',
  '/campaigns/informed-delivery/create-informed-delivery': 'Create Informed Delivery',
  '/campaigns/informed-delivery/edit-informed-delivery': 'Edit Informed Delivery',
  '/campaigns/informed-delivery/details': 'Informed Delivery Details',

  // EDDM routes
  '/eddm-campaigns': 'EDDM Campaigns',
  '/eddm-campaigns/create-eddm-campaign': 'Create EDDM Campaign',
  '/eddm-campaigns/details': 'EDDM Campaign Details',

  // Ads routes
  '/ads': 'Digital Ads',
  '/ads/details': 'Details',
  '/ads/edit': 'Edit',
  '/ads/new-ad-campaign': 'New Digital Ad Campaign',

  // Journeys routes
  '/journeys': 'Journeys',

  // Predictions routes
  '/predictions': 'Predictions Studio',
  '/test-predictions': 'Test Predictions',

  // Other routes
  '/pricing': 'Pricing',
  '/products': 'Products',
  '/logic': 'Logic / Rules',
  '/logic/preview': 'Logic Preview',
  '/analyzer': 'Campaign Analyzer',
  '/generator': 'Content Generator',
  '/templates': 'Content Templates',
  '/voice-campaigns': 'Voice Campaigns',
  '/voice-analytics': 'Voice Analytics',
  '/arc/builder': 'Campaign Builder',
  '/arc/budget': 'Budget Optimizer',
  '/campaign-analytics': 'Campaign Analytics',
  '/attribution': 'Attribution',
  '/design': 'Design',
  '/editor': 'Editor',
  '/editor-demo': 'Editor Demo',
  '/image-editor': 'Image Editor',
  '/quote': 'Quote',
  '/schedule': 'Schedule',
  '/service': 'Service',
  '/email': 'Email',
  '/email/new-email-campaign': 'New Email Campaign',
  '/email/preview': 'Email Preview',
  '/email/edit': 'Edit Email',
  '/qr-preview': 'QR Preview',
  '/transaction-status': 'Transaction Status',
  '/tiers': 'Tiers',
  '/dashboard': 'Dashboard',
  '/executive': 'Dashboard',
  '/account/brands/new': 'Create Brand Kit',
  '/account/brands/edit': 'Edit Brand Kit'

  // Add more custom route mappings as needed
  // Example: '/custom-route': 'Custom Display Name',
};
